export default "assets/images/icons/search-a1cf1078.svg";